export const SHIP_UPDATED = "SHIP_UPDATED";
export const START_DATE_UPDATED = "START_DATE_UPDATED";
export const END_DATE_UPDATED = "END_DATE_UPDATED";